module.exports = __webpack_public_path__ + "img/046-student.ff60771f.png";